// src/components/cart/CartSummary.jsx
import React, { useMemo, useEffect } from "react";
import { motion } from "framer-motion";
import { ShoppingBag, ShoppingCart, Loader } from "lucide-react";

const CartSummary = ({
  subtotal,
  shippingCost,
  totalPrice,
  currency,
  setScreen,
  handleBuyNow,
  loading,
  cartItems,
}) => {
  // 🧾 Debug logs
  console.log("🛍️ Cart Data:");
  console.log("Cart Items:", cartItems);
  console.log("Subtotal:", subtotal);
  console.log("Shipping Cost:", shippingCost);
  console.log("Total Price:", totalPrice);

  // ✅ Handle Buy Now click: 
  const handleBuyNowClick = () => {
    if (typeof handleBuyNow === "function") {
      handleBuyNow();
    }
  };

  return (
    <div className="mt-6">
      <div className="text-gray-800 dark:text-gray-400 bg-primary dark:bg-primary-dark p-4 rounded-lg space-y-2">
        <p>Subtotal: {currency} {subtotal.toFixed(2)}</p>
        <p>Shipping: {currency} {shippingCost.toFixed(2)}</p>

        <p className="text-black dark:text-white font-bold text-lg pt-2 border-t border-white/10">
          Total: {currency} {totalPrice.toFixed(2)}
        </p>
      </div>

      <div className="flex flex-wrap gap-4 mt-8">
        <motion.button
          onClick={() => setScreen("/shop")}
          className="flex items-center justify-center px-6 py-3 border border-[#DBAE6E] text-[#DBAE6E] rounded-lg text-lg font-medium w-full sm:w-auto"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <ShoppingBag size={22} className="inline mr-2" /> Continue Shopping
        </motion.button>

        <motion.button
          onClick={handleBuyNowClick} // ✅ updated
          className="flex items-center justify-center px-8 py-4 bg-[#DBAE6E] text-black rounded-lg text-lg font-semibold w-full sm:w-auto"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          disabled={loading || !cartItems.length}
        >
          {loading ? (
            <Loader size={24} className="animate-spin" />
          ) : (
            <>
              <ShoppingCart size={24} className="inline mr-2" /> Buy Now
            </>
          )}
        </motion.button>
      </div>
    </div>
  );
};

export default CartSummary;
